import { render, staticRenderFns } from "./SubirVersion.vue?vue&type=template&id=fccb222a&"
import script from "./SubirVersion.vue?vue&type=script&lang=js&"
export * from "./SubirVersion.vue?vue&type=script&lang=js&"
import style0 from "./SubirVersion.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports